import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { LangContext } from "../../context/LangContext";
import { getImageAlt } from "../../utils/imageAlt";
import "./cat.css";

const CSRCat = () => {
  const lang = useContext(LangContext);
  const nep = lang.state.np;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        "https://admin.icfcbank.com/api/csr/csr_type/",
      );
      setData(res.data.items);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Failed to load data.</div>;

  const categories = nep ? data?.np || [] : data?.en || [];
  console.log("CSR Categories:", categories);
  return (
    <div className="csr_cat_box">
      {categories.map((item) => {
        // 🔑 Route logic
        let linkTo = `/csr/lists/${item.id}`;

        if (item.id === "16") {
          linkTo = "/csr/expensesreports";
        }

        return (
          <div className="cat_items" key={item.id}>
            <div className="cat_image">
              {item?.DocPath ? (
                <Link to={linkTo}>
                  <img src={item.DocPath} alt={getImageAlt(item, item.Title)} />
                </Link>
              ) : (
                <div className="no-image">No Image</div>
              )}
            </div>

            <div className="cat_title">
              <h1>
                <Link to={linkTo}>{item?.Title}</Link>
              </h1>

              <Link className="CSRBTN" to={linkTo}>
                Explore
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CSRCat;
